import type { HTMLProps } from "react"
import { forwardRef } from "react"

type Props = HTMLProps<HTMLInputElement> & {
  isError?: boolean
  errorMessage?: string
}

export const TextField = forwardRef<HTMLInputElement, Props>(
  ({ isError = false, errorMessage, className, ...props }, ref) => {
    return (
      <div className="flex flex-col">
        <input
          {...props}
          ref={ref}
          className={`w-full rounded-[6px] border bg-white px-3 py-2 text-[14px] leading-[1.6] text-black placeholder:text-[14px] placeholder:leading-[1.6] placeholder:text-[#838892] focus:outline-none ${
            isError ? "border-[#FF3B30] focus:border-[#FF3B30]" : "border-[#d6d8dd] focus:border-[#d6d8dd]"
          } ${className || ""}`}
        />
        {isError && errorMessage && (
          <span className="mt-1 text-[14px] font-normal leading-[1.6] text-[#ff3b30]">{errorMessage}</span>
        )}
      </div>
    )
  },
)
